import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home';
import CreatePatient from './views/Doctor/CreatePatient';
import Promo from './views/Doctor/Promo';
import Help from './views/Doctor/Help';
import FinalScreen from './views/Doctor/FinalScreen';

import Stage1 from './views/Doctor/Stages/Stage1';
import Stage2 from './views/Doctor/Stages/Stage2';
import PatientResults from './views/Doctor/Stages/PatientResults';

import Man18_60_S1 from './views/Doctor/Stages/Man/18-60/Stage1';
import Man18_60_S2 from './views/Doctor/Stages/Man/18-60/Stage2';
import Man18_60_S2_isBaseKt from './views/Doctor/Stages/Man/18-60/Stage3';
import Man18_60_S2_him from './views/Doctor/Stages/Man/18-60/Stage4';
import Man18_60_S2_abvd_kt from './views/Doctor/Stages/Man/18-60/Kt1';
import Man18_60_S2_beacopp_kt from './views/Doctor/Stages/Man/18-60/Kt2';
import Man18_60_S2_biopsy_result from './views/Doctor/Stages/Man/18-60/BiopsyResult';
import ByEffect1 from './views/Doctor/Stages/ByEffects/Effect1';
import Anamnes from './views/Doctor/Stages/ByEffects/Anamnes';
import FertilAnamnes from './views/Doctor/Stages/ByEffects/FertilAnamnes';

import NoEvents from './views/Doctor/NoEvents';
import NoValidEvent from './views/Doctor/NoValidEvent';
import SelectEvent from './views/Doctor/SelectEvent';

import Login from './views/Login.vue';
import Patients from './views/Moderator/Patients';
import Patient from './views/Moderator/Patient';
import Admin from './views/Admin/Admin';

import Events from './views/Admin/Events';

import AdminListEvents from './views/Admin/Events/List';
import AdminAddEvent from './views/Admin/Events/Add';

import Moderators from './views/Admin/Moderators';

import AdminListModerators from './views/Admin/Moderators/List';
import AdminAddModerator from './views/Admin/Moderators/Add';

import AdminPatients from './views/Admin/Patients';

import AdminPatientsImages from './views/Admin/Patients/Images';
import AdminPatientsList from './views/Admin/Patients/PatientsList';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path : '/',
      name : 'home',
      component : Home
    },
    {
      path : '/event/:id',
      name : 'event',
      component : Home
    },
    {
      path : '/create-patient',
      component : CreatePatient,
      children : [
        {
          path : '',
          component : Stage1
        },
        {
          path : 'stage/1',
          component : Stage1
        },
        {
          path : 'stage/2',
          component : Stage2
        },
        {
          path : 'man/18-60/1',
          component : Man18_60_S1
        },
        {
          path : 'man/18-60/2',
          component : Man18_60_S2
        },
        {
          path : 'man/18-60/2/isBaseKt',
          component : Man18_60_S2_isBaseKt
        },
        {
          path : 'man/18-60/2/him',
          component : Man18_60_S2_him
        },
        {
          path : 'man/18-60/2/him/kt/1',
          component : Man18_60_S2_abvd_kt
        },
        {
          path : 'man/18-60/2/him/kt/2',
          component : Man18_60_S2_beacopp_kt
        },
        {
          path : 'biopsy-result',
          component : Man18_60_S2_biopsy_result
        },
        {
          path : 'anamnes',
          component : Anamnes
        },
        {
          path: 'fertil-anamnes',
          component : FertilAnamnes
        },
        {
          path : 'by-effect/1',
          component : ByEffect1
        }
      ]
    },
    {
      path : '/patient-results',
      component : PatientResults
    },
    {
      path : '/promo',
      component : Promo
    },
    {
      path : '/final-screen',
      component : FinalScreen
    },
    {
      path : '/help',
      component : Help
    },
    {
      path : '/no-events',
      component : NoEvents
    },
    {
      path : '/room-not-exist',
      component : NoValidEvent
    },
    {
      path : '/select-conference/:events',
      name : 'select-conference',
      component : SelectEvent
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path : '/patients',
      name : 'patients',
      component : Patients,
      meta : {
        requiresAuth: true
      }
    },
    {
      path : '/patient/:index',
      name : 'patient',
      component : Patient,
      meta : {
        requiresAuth : true
      }
    },
    {
      path : '/admin',
      name : 'admin',
      component : Admin,
      meta : {
        requiresAuth: true
      },
      children: [
        {
          path : 'events',
          component : Events,
          children : [
            {
              path: '/',
              component : AdminListEvents
            },
            {
              path : 'add-event',
              component : AdminAddEvent
            }
          ]
        },
        {
          path : 'moderators',
          component : Moderators,
          children : [
            {
              path : '/',
              component : AdminListModerators
            },
            {
              path : 'add-moderator',
              component : AdminAddModerator
            }
          ]
        },
        {
          path : 'patients',
          component : AdminPatients,
          children : [
            {
              path : '/',
              component : AdminPatientsList
            },
            {
              path : 'images',
              component : AdminPatientsImages
            }
          ]
        }
      ]
    }
  ],
  mode: 'history'
})